import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from '../../api';
import { INIT_QUIZ_DATA } from '../../constants';

export const fetchQuiz = createAsyncThunk('quiz/fetchQuiz', async ({ website_id }) => {
  const { quizz } = await api.sites().getOne(website_id)
  return quizz
})

const quizSlice = createSlice({
  name: 'quiz',
  initialState: INIT_QUIZ_DATA,
  reducers: {
    updateQuiz: (state, action) => {
      for (const question in state) {
        if (!(question in action.payload)) continue;
        state[question] = action.payload[question];
      }
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchQuiz.pending, state => {
      state.loading = true
    })
      .addCase(fetchQuiz.fulfilled, (state, { payload }) => {
        state.loading = false
        for (const question in state) {
          if (!(question in payload)) continue;
          state[question] = payload[question];
        }
      })
      .addCase(fetchQuiz.rejected, (state, { error }) => {

        for (const question in INIT_QUIZ_DATA) {
          state[question] = INIT_QUIZ_DATA[question]
        }
        console.log(error);
      })
  }
});

export const { updateQuiz } = quizSlice.actions;
export const selectorQuiz = (state) => state.quiz;

export default quizSlice.reducer;
